var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { Col, TextLabel } from '../../atoms';
import { theme } from '@xbto/design-system';
export function CountLabel(_a) {
    var { count } = _a, rest = __rest(_a, ["count"]);
    return (_jsx(Col.C, Object.assign({ style: $.container }, rest, { children: _jsx(TextLabel, { xem: true, color: "inverse", children: count }) })));
}
const $ = StyleSheet.create({
    container: {
        width: theme.spacing['4'],
        height: theme.spacing['4'],
        backgroundColor: theme.color.background.primary,
        borderRadius: theme.radius.full,
    },
});
